// Shared by the page (LockHandler pagehide) and the dashboard shared worker (lockRegistry replay),
// so this module must stay free of axios/DOM imports — it gets bundled into the worker.

/**
 * Identity key for a lock. ASP.NET routes are case-insensitive and call sites disagree on casing —
 * PrescriptionDetailsPage asks for `/IngestionQueue/5/Lock` while IngestionComponent asks for
 * `/IngestionQueue/5/lock` — so two tabs on one record would otherwise look like two locks. Only
 * ever a map key; requests still go to the URL as the caller spelled it.
 */
export function lockUrlKey(url: string): string {
    return url.toLowerCase();
}

/**
 * Releases a lock with a keepalive fetch so the request outlives a closing document or a dying
 * worker — axios can't be used here because its XHR is aborted on unload. Never throws; a failed
 * release falls back to server-side expiry.
 */
export function postKeepaliveRelease(url: string, auth: string | null, fetchImpl: typeof fetch = fetch): void {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (auth) headers.Authorization = auth;

    try {
        void fetchImpl(url, {
            method: 'POST',
            keepalive: true,
            // The axios call this stands in for runs under axios.defaults.withCredentials, and the
            // API's CORS policy allows credentials; fetch would otherwise default to same-origin and
            // send the release without the cookies its acquire and heartbeat carried.
            credentials: 'include',
            headers,
            body: 'true',
        }).then(response => {
            // An expired token comes back 401, which is otherwise indistinguishable from success.
            if (!response?.ok) {
                console.warn(`Keepalive lock release rejected (${response?.status}) for ${url}`);
            }
        }).catch(error => {
            console.warn(`Keepalive lock release failed for ${url}:`, error);
        });
    } catch (error) {
        console.warn(`Keepalive lock release could not be sent for ${url}:`, error);
    }
}
